import { Wrench } from "lucide-react";
import { getServiceIcon } from "@/lib/serviceIcons";

// Bloque Servicios · Cobro directo — presentacional.
export const ServiciosDirectos = ({ serviciosSuc, abrirCobroServicio, caja }) => (
  <div className="border border-white/10 bg-white/[0.02] p-5" data-testid="bloque-servicios">
    <div className="flex items-center gap-2 mb-3">
      <Wrench className="h-5 w-5 text-[#FFCC00]" />
      <h3 className="font-display text-lg font-black tracking-tight">Servicios · Cobro directo</h3>
    </div>
    {serviciosSuc.length > 0 ? (
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-testid="servicios-grid">
        {serviciosSuc.map((s) => {
          const SvcIcon = getServiceIcon(s.icono);
          return (
            <button key={s.id_servicio} onClick={() => abrirCobroServicio(s)} disabled={!caja}
              data-testid={`servicio-${s.id_servicio}`}
              className="btn-hard group bg-white/5 border border-white/20 hover:border-[#FFCC00] hover:bg-[#FFCC00]/5 disabled:opacity-40 disabled:cursor-not-allowed p-4 flex flex-col items-center justify-center gap-2 min-h-[110px] transition-colors duration-200">
              <SvcIcon className="h-8 w-8 text-[#FFCC00]" strokeWidth={1.5} />
              <span className="font-display text-sm font-bold tracking-tight text-center leading-tight">{s.nombre}</span>
              <span className="text-[11px] font-bold uppercase tracking-wider text-white/40">${Number(s.precio || 0).toFixed(2)}</span>
            </button>
          );
        })}
      </div>
    ) : (
      <p className="text-white/30 text-xs py-8 text-center border border-white/10" data-testid="servicios-empty">No hay servicios configurados en esta sucursal.</p>
    )}
  </div>
);

export default ServiciosDirectos;
